import { QK } from 'ck-queries';
import { ThemeDto } from './types';
import { fetchWithErrorThrowing } from 'ck-utils';
import { formatThemeData } from './localUtils';
import { useQuery } from '@tanstack/react-query';

// Query hook
export const useThemeDraft = () =>
  useQuery({
    queryKey: QK.themes.draft,
    queryFn: getThemesDraft,
  });

// Query function
export async function getThemesDraft(): Promise<ThemeDto[]> {
  const res = await fetchWithErrorThrowing('/themes/draft', {
    method: 'GET',
  });

  const data: { themes: ThemeDto[] } = await res.json();

  return formatThemeData(data.themes);
}
